import type { SvgIconComponent } from '@mui/icons-material';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import RecordVoiceOverOutlinedIcon from '@mui/icons-material/RecordVoiceOverOutlined';
import RoomServiceOutlinedIcon from '@mui/icons-material/RoomServiceOutlined';
import { TrackerDataType } from './constants';

export const sidebarLogIconByType: Partial<Record<TrackerDataType, SvgIconComponent>> = {
  [TrackerDataType.SERVICE]: RoomServiceOutlinedIcon,
  [TrackerDataType.MEDIA_INTERACTION]: RecordVoiceOverOutlinedIcon,
  [TrackerDataType.ENGAGEMENT]: HandshakeOutlinedIcon,
  [TrackerDataType.CONTENT_LOG]: DescriptionOutlinedIcon,
};

export const getSidebarLogIconComponent = (logtype?: TrackerDataType | null): SvgIconComponent =>
  (logtype ? sidebarLogIconByType[logtype] : undefined) ?? RoomServiceOutlinedIcon;
